import { useEffect, useRef } from 'react'
import { io } from 'socket.io-client'

/** Regiepagina: luistert naar wijzigingen in de schermenlijst. */
export function useScreensSocket(onChange) {
  const cbRef = useRef(onChange)
  useEffect(() => { cbRef.current = onChange }, [onChange])

  useEffect(() => {
    const token = localStorage.getItem('auth_token')
    if (!token) return
    const s = io({ auth: { token }, transports: ['polling', 'websocket'], reconnection: true })
    const subscribe = () => s.emit('screens:subscribe')
    s.on('connect', subscribe)
    s.on('reconnect', subscribe)
    s.on('screens:changed', (p) => { try { cbRef.current?.(p) } catch (e) { console.error(e) } })
    return () => {
      try { s.emit('screens:unsubscribe') } catch {}
      s.removeAllListeners(); s.disconnect()
    }
  }, [])
}

/** Eén fysiek scherm: meldt zich aan onder zijn slug en krijgt navigatie-opdrachten. */
export function useScreenChannel(slug, onNavigate) {
  const cbRef = useRef(onNavigate)
  useEffect(() => { cbRef.current = onNavigate }, [onNavigate])

  useEffect(() => {
    if (!slug) return
    // Ontvanger-pagina's (OBS-browser-source, beamer) hebben géén auth_token —
    // toch een socket openen zonder token zodat scherm:navigate direct doorkomt.
    // Backend accepteert anonieme handshakes (socket.user = null).
    const token = localStorage.getItem('auth_token') || undefined
    const s = io({ auth: { token }, transports: ['polling', 'websocket'], reconnection: true })
    const attach = () => s.emit('screen:attach', { slug })
    s.on('connect', attach)
    s.on('reconnect', attach)
    s.on('screen:navigate', (p) => { try { cbRef.current?.(p) } catch (e) { console.error(e) } })
    return () => {
      try { s.emit('screen:detach', { slug }) } catch {}
      s.removeAllListeners(); s.disconnect()
    }
  }, [slug])
}

/** Luistert of de regie de rotatie-instellingen van dit scherm wijzigt. */
export function useScreenRotation(slug, onRotation) {
  const cbRef = useRef(onRotation)
  useEffect(() => { cbRef.current = onRotation }, [onRotation])

  useEffect(() => {
    if (!slug) return
    // Zelfde als hierboven: ontvangers zonder token mogen ook de rotation-
    // room joinen; backend accepteert anonieme sockets.
    const token = localStorage.getItem('auth_token') || undefined
    const s = io({ auth: { token }, transports: ['polling', 'websocket'], reconnection: true })
    const attach = () => s.emit('screen:attach', { slug })
    s.on('connect', attach)
    s.on('reconnect', attach)
    s.on('screen:rotation', (p) => { try { cbRef.current?.(p) } catch (e) { console.error(e) } })
    return () => {
      try { s.emit('screen:detach', { slug }) } catch {}
      s.removeAllListeners(); s.disconnect()
    }
  }, [slug])
}
